import React from 'react';
import PropTypes from 'prop-types';
import { InfoAlert } from 'smartsuite-ui';

export default function IssueDisplay(props) {
    return (
        <InfoAlert>
            <div>
                <div>
                    An error occurred and Bag Summary cannot present the
                    timeline of the bag.
                </div>
                <div>
                    Go to Bag Details to see all of the events:{' '}
                    <a href={props.bagDetailsUrl}>Bag Details.</a>
                </div>
            </div>
        </InfoAlert>
    );
}

IssueDisplay.propTypes = {
    bagDetailsUrl: PropTypes.string.isRequired,
};
